import React from "react";
import { useParams } from "react-router-dom";
import AuditTrailsTable from "../../common/AuditTrailsTable";
import {
    GetLtiIntegrationAuditTrail,
    GetLtiIntegrationAuditTrailFilters,
} from "../../../services/LtiIntegrationService";

/**
 * LTI integrations audit trail list (reuses shared AuditTrailsTable).
 * When opened from an integration detail page, filters by that integration id.
 */
function AuditTrail() {
    const { id } = useParams();
    const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

    const handleRedirect = (resourceId) => {
        return `/administration/integrations/open/${resourceId}/details`;
    };

    return (
        <AuditTrailsTable
            apiFunction={GetLtiIntegrationAuditTrail}
            filterArrApi={GetLtiIntegrationAuditTrailFilters}
            columnsToShow={columnsToShow}
            exportFileName="LTI_Integrations_Audit_Trail"
            resourceNameRedirect={handleRedirect}
            isShowingResourceTypeFilter
            isResourceNameShown={true}
            actionId={id}
            apiParams={id ? { action_id: id } : {}}
        />
    );
}

export default AuditTrail;
